import React from 'react';
import { styled } from '@linaria/react';

import Button from '@/components/LegacyButton';
import ShiftBy from '@/components/ShiftBy';

function LeftAlignDemo() {
  const [isAligned, setIsAligned] = React.useState(true);

  return (
    <Wrapper>
      <InnerWrapper>
        <ShiftBy x={isAligned ? -3 : 0}>
          <Heading>Hello World</Heading>
        </ShiftBy>
        <p>
          This is a paragraph below a heading. This paragraph has many
          words, and you might imagine it has very important things!
        </p>
      </InnerWrapper>
      <Button
        onClick={() => {
          setIsAligned(!isAligned);
        }}
      >
        Toggle
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
`;

const InnerWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  border: 2px dotted var(--color-gray-300);
  padding: 32px;
  margin-bottom: 32px;
`;

const Heading = styled.div`
  font-size: 64px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default LeftAlignDemo;
